import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { SceneObjectBase } from '../../core/SceneObjectBase.js';
import { renderSceneComponentWithRouteProps } from './utils.js';

class SceneApp extends SceneObjectBase {
}
SceneApp.Component = ({ model }) => {
  const { pages } = model.useState();
  return /* @__PURE__ */ React.createElement(Switch, null, pages.map((page) => /* @__PURE__ */ React.createElement(Route, {
    key: page.state.url,
    exact: false,
    path: page.state.url,
    render: (props) => renderSceneComponentWithRouteProps(page, props)
  })));
};

export { SceneApp };
//# sourceMappingURL=SceneApp.js.map
